import React from "react";
import { Shield, Lock, Sparkles, AlertTriangle } from "lucide-react";
import { EmergencyBanner } from "@/components/shared/Common";

const Card = ({ icon, title, children }) => (
  <div className="cm-card">
    <div className="w-11 h-11 rounded-lg bg-[#ebf3fc] text-[#4a90d9] flex items-center justify-center mb-4">{icon}</div>
    <h3 className="font-semibold text-[#1a2b4a] mb-2">{title}</h3>
    <div className="text-sm text-[#475569] leading-relaxed">{children}</div>
  </div>
);

export default function TrustSafety() {
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl">
        <div className="cm-eyebrow mb-2">Trust &amp; Safety</div>
        <h1 className="cm-h2">Safety is the first step of care.</h1>
        <p className="cm-body mt-3">CAREMatch is built on verified doctors, encrypted data and transparent AI. Here's what that means in practice.</p>
      </div>
      <div className="mt-6"><EmergencyBanner/></div>
      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card icon={<Shield size={20}/>} title="Doctor verification">Every doctor is checked against the GMC (or equivalent) register, holds professional indemnity insurance and has verified qualifications and ID before their profile goes live.</Card>
        <Card icon={<Lock size={20}/>} title="Data privacy">Consultations and documents are encrypted at rest and in transit. Your Care Passport is yours &mdash; export or delete at any time.</Card>
        <Card icon={<Sparkles size={20}/>} title="AI transparency">Every AI-generated summary is clearly labelled. Doctors review before use, and the AI never makes a diagnosis.</Card>
        <Card icon={<AlertTriangle size={20}/>} title="Emergency guidance">If any red-flag symptoms are detected during intake, we pause the flow and direct you to 999 or A&amp;E immediately.</Card>
      </div>
    </div>
  );
}
